export default __webpack_public_path__ + "static/media/Memo Shortcut-1753349816611.4638ffb0.png";